import React from "react";
import "./../../../style.scss";
import { TableHead, TableRow, TableCell, withStyles } from "@material-ui/core";
import styles from "./styles";
import StyledTooltip from "../../../../../common/StyledToolTip";

const Header = ({
  name,
  address,
  id,
  stopSequence,
  classes,
  isDelayStop = false,
  Marker,
  markerProps={}
}) => {
  return (
    <TableHead
      className={isDelayStop ? classes.tableHeadDelayStop : classes.tableHead}
    >
      <TableRow className={classes.tableHeadHeight}>
        <TableCell colSpan={2}>
          <div>
            <span className={classes.pickupMarker} style={{ float: "left" }}>
              <Marker
                stopNo={stopSequence}
                {...markerProps}
              />
            </span>
            <span className={classes.tableHeaderCell}>
              <div className={classes.nameContainer}>
                <StyledTooltip title={name}>
                  <span
                    className={`${classes.name} ${id ? "" : classes.maxWidth}`}
                  >
                    {name}
                  </span>
                </StyledTooltip>
                {id && (
                  <StyledTooltip title={`#${id}`}>
                    <span className={classes.accountNumber}>{`#${id}`}</span>
                  </StyledTooltip>
                )}
              </div>
              <StyledTooltip title={address}>
                <div className={classes.address}>{address}</div>
              </StyledTooltip>
            </span>
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default withStyles(styles)(Header);
